export default __webpack_public_path__ + "bc9a99461a9c2508cdf5b2f7d61f34d4.png";